"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Link from "./webflow_modules/Basic/components/Link";

export function AdvSearchSearchInputDropDownItem({
  buttonProps = {},
  showDisabled = true,
  showEnabled = true,
  text = "Market Name",
}) {
  return (
    <Block className={"adv-search---result-item-container"} tag={"div"}>
      {showDisabled ? (
        <Link
          block={"inline"}
          button={false}
          className={"search-results-link-block"}
          options={{
            href: "#",
          }}
          {...buttonProps}
        >
          <Block className={"search-results---submarket-container"} tag={"div"}>
            <Block className={"results-text-blcok"} tag={"div"}>
              {text}
            </Block>
          </Block>
        </Link>
      ) : null}
      {showEnabled ? (
        <Block className={"search-results-link-block enabled"} tag={"div"}>
          <Block className={"search-results---submarket-container"} tag={"div"}>
            <Block className={"results-text-blcok"} tag={"div"}>
              {text}
            </Block>
          </Block>
        </Block>
      ) : null}
    </Block>
  );
}
